import { buildReducer } from '../../utils/redux/getReduxModuleByFeatureName';
import getConstantsByFeatureName from '../../utils/redux/getConstantsByFeatureName';
import getActionCreators from '../../utils/redux/getActionCreators';
import getActionHandlers from '../../utils/redux/getActionHandlers';
import getSelectorByFeatureName from '../../utils/redux/getSelectorByFeatureName';
import getCRUDSagas from '../../utils/redux/getCRUDSagas';
import { initialState } from '../../utils/redux/commonActionHandlers';
import Api from '../../utils/Api';


const constantsPrefix = 'CREWING-AGENTS';
const statePropName = 'crewingAgents';
const formStatePropName = 'crewingAgents';
const mainPageUrl = '/crewing-agents';

const constants = getConstantsByFeatureName(constantsPrefix);
const actions = getActionCreators(constants);
const actionHandlers = getActionHandlers(constants);
const reducer = buildReducer(initialState, actionHandlers);
const selector = getSelectorByFeatureName(statePropName);

const sagas = getCRUDSagas(
  mainPageUrl,
  Api.crewingAgents,
  actions,
  constants,
  formStatePropName,
  statePropName,
  { itemName: 'Crewing agent' },
);

export { constants, actions, reducer, selector, sagas };
